module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/speedtest.4c5602d4.png";